import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { DataLoadingCard, PersistentDataGrid } from 'common';
import { useGetDestinationsQuery } from './destinationsEndpoints';

const Destinations = () => {
  const columns = [
    {
      field: 'destinationAddressLine1',
      headerName: 'Address Line 1',
      width: 150,
    },
    {
      field: 'destinationAddressLine2',
      headerName: 'Address Line 2',
      width: 150,
    },
    {
      field: 'destinationCity',
      headerName: 'City',
      width: 150,
    },
    {
      field: 'destinationState',
      headerName: 'State',
      width: 150,
    },
    {
      field: 'globalDestinationId',
      headerName: 'Global Id',
      width: 150,
    },
    {
      field: 'globalDestinationName',
      headerName: 'Global Name',
      width: 200,
    },
    {
      align: 'center',
      field: 'locationDestinationId',
      headerName: 'Location Destination Id',
      width: 200,
    },
    {
      align: 'center',
      field: 'locationId',
      headerName: 'Location Id',
    },
    {
      field: 'locationName',
      headerName: 'Location Name',
      width: 200,
    },
    {
      align: 'center',
      field: 'productionPlant',
      headerName: 'Production Plant',
      width: 150,
    },
    {
      field: 'updatedDateTime',
      headerName: 'Update Date & Time',
      width: 200,
    },
  ];

  const [filters, setFilters] = useState({
    id: '',
    locationDestinationId: '',
    locationId: '',
    locationName: '',
    name: '',
    state: '',
  });
  const [params, setParams] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 100,
  });

  const handleSearch = () => {
    setParams({ ...filters });
  };

  const clearSearch = () => {
    setFilters({
      id: '',
      locationDestinationId: '',
      locationId: '',
      locationName: '',
      name: '',
      state: '',
    });
    setParams({});
  };

  const { data: destinationsData = [], isFetching: isFetchingDestinations = false } =
    useGetDestinationsQuery({ ...paginationModel, ...params });

  return (
    <div style={{ padding: 1, pb: 0, width: '100%' }}>
      <div
        style={{
          height: 'calc(100vh - 79px)',
          marginTop: '50px',
          padding: 30,
          pb: 0,
          width: '100%',
        }}
      >
        <Box style={{ marginBottom: '10px', textAlign: 'left' }}>
          <TextField
            label="Location Name"
            name="locationName"
            onChange={event => {
              setFilters({
                ...filters,
                locationName: event.target.value,
              });
            }}
            sx={{ m: '5px' }}
            value={filters.locationName}
          />
          <TextField
            label="Location Id"
            name="locationId"
            onChange={event => {
              setFilters({
                ...filters,
                locationId: event.target.value,
              });
            }}
            sx={{ m: '5px' }}
            value={filters.locationId}
          />
          <TextField
            label="Location Destination Id"
            name="locationDestinationId"
            onChange={event => {
              setFilters({
                ...filters,
                locationDestinationId: event.target.value,
              });
            }}
            sx={{ m: '5px' }}
            value={filters.locationDestinationId}
          />
          <TextField
            label="Global Destination Id"
            name="id"
            onChange={event => {
              setFilters({
                ...filters,
                id: event.target.value,
              });
            }}
            sx={{ m: '5px' }}
            value={filters.id}
          />
          <TextField
            label="Global Destination Name"
            name="name"
            onChange={event => {
              setFilters({
                ...filters,
                name: event.target.value,
              });
            }}
            sx={{ m: '5px' }}
            value={filters.name}
          />
          <TextField
            label="Global Destination State"
            name="state"
            onChange={event => {
              setFilters({
                ...filters,
                state: event.target.value,
              });
            }}
            sx={{ m: '5px' }}
            value={filters.state}
          />
          <Button onClick={clearSearch} sx={{ m: '7px' }} variant="outlined">
            Clear
          </Button>
          <Button onClick={handleSearch} sx={{ m: '7px' }}>
            Search
          </Button>
        </Box>
        {isFetchingDestinations ? (
          <Box
            sx={{
              p: theme => ({ lg: theme.spacing(4, 1, 1), xs: theme.spacing(9, 3, 4) }),
              textAlign: 'center',
            }}
          >
            <DataLoadingCard type="data" />
          </Box>
        ) : (
          <PersistentDataGrid
            columns={columns}
            getRowId={row =>
              `${row.globalDestinationId}-${row.locationDestinationId}-${row.locationId}`
            }
            loading={isFetchingDestinations}
            onPaginationModelChange={setPaginationModel}
            pagination
            paginationMode="server"
            persist={false}
            rowCount={destinationsData?.totalRecords || 0}
            rows={destinationsData?.results || []}
            showFilterButton
            {...destinationsData}
            paginationModel={paginationModel}
          />
        )}
      </div>
    </div>
  );
};

export default Destinations;
